import { store, canUseLeave } from '@/stores/store';
export default {
  name: "HeaderUser",
  data: function data() {
    return {
      store: store
    };
  },
  methods: {
    canUseLeave: canUseLeave
  }
};